/**
 * 「创建 → 分镜 → 出片」当前步的派生(波1,D4)。
 *
 * 放 model 不放 ui:这是**从现有表单态算出来的一个值**,不是渲染。放在组件文件里会让
 * 那个文件同时导出组件和函数(react-refresh 因此失效),而且这条派生本身值得单独被测。
 * ★零新状态:三步全部读已有态,指示器只是把页面里本来就发生过的切换说出来。
 */

/** 1=创建(填 brief)· 2=分镜(导演台逐镜改)· 3=出片(提交生成) */
export type VideoStep = 1 | 2 | 3;

/**
 * @param hasStoryboard `form.panelScenes.length >= 1`(已编排出分镜)
 * @param rendering 正在提交出片
 */
export function videoStepOf(hasStoryboard: boolean, rendering: boolean): VideoStep {
  // 出片优先:提交中即第 3 步(此时分镜当然也在,但用户关心的是"正在出片")
  if (rendering) return 3;
  return hasStoryboard ? 2 : 1;
}
